import { graphql } from '@/gql'

export const DashboardMetricsQuery = graphql(/* GraphQL */ `
  query DashboardMetrics($accounts: [ID!]!, $from: Date, $to: Date) {
    unfilledJobs: jobs(
      accounts: $accounts
      unfilled: true
      createdAtDateRange: { from: $from, to: $to }
      isJobPost: true
    ) {
      paginatorInfo {
        total
      }
    }

    activeContracts: hires(
      accounts: $accounts
      activeStatus: [ACTIVE]
      createdAtDateRange: { from: $from, to: $to }
    ) {
      paginatorInfo {
        total
      }
    }

    unsignedContracts: hires(
      accounts: $accounts
      activeStatus: [OFFERED]
      createdAtDateRange: { from: $from, to: $to }
    ) {
      paginatorInfo {
        total
      }
    }

    talentPoolAppliedContacts: trustedContacts(
      accounts: $accounts
      statuses: [APPLIED]
  ) {
    paginatorInfo {
      total
    }
  }
}
`)